import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { Location } from "@/types/locationTypes.ts"

export const getLocations = async (): Promise<Location[]> => {
  const { data, error, response } = await apiClient.GET("/api/Locations")
  return assertOk(response, error, data)
}
